import { render, staticRenderFns } from "./modal-confirm_generic.html?vue&type=template&id=5a87b47f&scoped=true&external"
import script from "./modal-confirm_generic.js?vue&type=script&lang=js&external"
export * from "./modal-confirm_generic.js?vue&type=script&lang=js&external"
import style0 from "./modal-confirm_generic.scss?vue&type=style&index=0&id=5a87b47f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87b47f",
  null
  
)

export default component.exports